import React from "react";

const UpsellEcContent = ({content}) => {
  const {includedOptions,card,expertComptable,optionsContent} = content
  return(
    <section className="upsellEc-contentSection">
      <div className="upsellEc-content-rapper">
        <div className="upsellEc-content-options">
          {includedOptions && includedOptions.length && includedOptions.map((option,i) => {
            return (
              <div key={i} className="upsellEc-optionContainer">
                <img alt="" src={option.icon}/>
                <h3 className="upsellEc-optionTitle">{option.optionTitle}</h3>
                <p className="upsellEc-optionText">{option.optionText}</p>
              </div>
            )
          })}
        </div>
        <div className="upsellEc-content-profile">
          <h2 className="upsellEc-content-profileTitle">{expertComptable.title}</h2>
          <img className="upsellEc-content-profilePhoto" alt="" src={expertComptable.picture}/>
          <h3 className="upsellEc-content-profileName">{expertComptable.name}</h3>
          {expertComptable.description && expertComptable.description && expertComptable.description.map((text,i) => {
            return (
              <p key={i} className="upsellEc-content-profileText">{text}</p>
            )
          })}
        </div>
        <div className="upsellEc-content-options">
        {optionsContent && optionsContent.length && optionsContent.map((option,i) => {
            return (
              <div key={i} className="upsellEc-optionContainer">
                <img alt="" src={option.icon}/>
                <h3 className="upsellEc-optionTitle">{option.optionTitle}</h3>
                <p className="upsellEc-optionText profileOptionText">{option.optionText}
                </p>
              </div>
            )
          })} 
        </div>
      </div>
    </section>
  )
}
export default UpsellEcContent;



// WEBPACK FOOTER //
// ./src/components/buy/Upsell-EC/upsell-Ec-Content.js